module.exports = __webpack_public_path__ + "startpage-be63061f/lebenslauf-ausbildung-5b0ed381faad3e2429c320d0f41b47c8.jpg";